import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import {
    Button,
    Container,
    Col,
    Row,
    Table,
    Alert
} from "react-bootstrap";

import Guest from "../../../layouts/Guest";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faTicket, faCalendar } from '@fortawesome/free-solid-svg-icons';
import { createEvent } from 'ics';
import {
    Card, CardBody, CardSubtitle
} from 'reactstrap';
import { QRCodeCanvas } from "qrcode.react";
import html2canvas from "html2canvas";
import { useGuestContext } from "../../../contexts/GuestContext";
import { useHistory } from "react-router-dom";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import cuteVege1 from "../../../assets/img/baolinPrivate/cute_vege1.png";
import cuteVege2 from "../../../assets/img/baolinPrivate/cute_vege2.png";
import cuteMonk1 from "../../../assets/img/baolinPrivate/cute_monk1.png";
import cuteMonk2 from "../../../assets/img/baolinPrivate/cute_monk2.png";


function EventTicket() {
    const { language } = useGuestContext();
    const history = useHistory();
    const redirectToRegister = () => {
        history.push('/vegeregister');
    };
    const location = useLocation();
    // Extracting guestId from location.state or URL search parameters
    const params = new URLSearchParams(window.location.search);
    let guestId = location.state?.guestId || params.get('guestid') || params.get('id');
    const formattedGuestId = String(guestId).padStart(4, '0');
    // const eventName = language === "English" ? "Bao Lin Chan Monastery 15th Anniversary" : "寶林禪寺15週年慶法會";
    const eventName = (
        <span>
            Bao Lin Vege Fest Event Ticket
        </span>
    );


    const date = "13/04/2024";
    const time = "9:30";
    // /event/checkin is the Liang Huang check-in page; a Vege Fest ticket has to
    // point at its own.
    const qrValue = `${process.env.REACT_APP_SERVER_URL}/vegefest/checkin?id=${guestId}`;

    // Entry is staggered this year, so the ticket shows the window this guest chose.
    const [timeslot, setTimeslot] = useState(null);
    useEffect(() => {
        if (!guestId) return;
        axios.get(`${process.env.REACT_APP_SERVER_URL}/vegefest/guest-timeslot?guestid=${guestId}`)
            .then((response) => setTimeslot(response.data.timeslot || null))
            .catch((error) => {
                // Fall back to the overall opening hours rather than showing nothing.
                console.error('Could not load the entry time for this ticket:', error);
                setTimeslot(null);
            });
    }, [guestId]);

    const addToCalendar = () => {
        // const event = {
        //     start: [2023, 4, 24, 9, 0],
        //     duration: { hours: 2 }, // Assuming 2 hours duration, adjust as needed
        //     title: eventName,
        //     description: document.getElementById('ticket-content').innerText,
        //     status: 'CONFIRMED',
        //     busyStatus: 'BUSY',
        // };
        const event = {
            start: [process.env.EVENT_DATE_YEAR, process.env.EVENT_DATE_MONTH, process.env.EVENT_DATE_DAY, process.env.EVENT_START_TIME_HOUR, process.env.EVENT_START_TIME_MIN],
            duration: { hours: 3 }, // Assuming 2 hours duration, adjust as needed
            title: "Bao Lin 15th Anniversary Ceremony and Transmission of Three Refuges & Five Precepts",
            description: "Description of the event", // Add a meaningful description
            status: 'CONFIRMED',
            busyStatus: 'BUSY',
        };

        createEvent(event, (error, value) => {

            if (error) {
                console.error('Error creating ICS', error);
                return;
            }
            const blob = new Blob([value], { type: 'text/calendar;charset=utf-8' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = 'baolin_15th_ann_event.ics'; // File name for the downloaded file
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        });
    };

    const Announcement = (
        <>
            <Alert className="alert-with-icon" variant="info">
                <span
                    data-notify="icon"
                    className="nc-icon nc-bell-55"
                ></span>
                <span data-notify="message font-weight-bold">
                    溫馨提醒：本週六(13/4)寶林十五週年慶，上午8:30開放報到，請於9:30前就座。因人數眾多停車不易，精舍從上午6:45~9:30安排往返Glen Iris Station的接駁車，請盡量搭乘。精舍前High St. 和Allison Ave.禁止停車。當日不開放置物櫃，個人物品請務必隨身保管。您的Guest ID和QR code已寄到email，期待您共同參與盛會！
                </span>
                <span data-notify="message">

                </span>
            </Alert>
            <Alert className="alert-with-icon mt-1" variant="success">
                <span
                    data-notify="icon"
                    className="nc-icon nc-bell-55"
                ></span>
                <span data-notify="message">
                    Friendly reminder: Bao Lin's 15th Anniversary is on 13/4 (Sat). Check-in begins at 8:30 AM. Please be seated by 9:30 AM. Due to limited parking, shuttle service to and from Glen Iris Station runs from 6:45 AM to 9:30 AM. No parking on High St in front of Bao Lin & Allison Ave. Lockers will not be available on that day, so please keep your personal belongings with you at all times. Guest ID & QR code will be sent via email. Looking forward to your presence.
                </span>
            </Alert>
        </>
    )

    const downloadImage = () => {
        const input = document.getElementById('ticket-for-download');
        html2canvas(input, {
            scale: 1,
            logging: true,
            useCORS: true,
        }).then((canvas) => {
            const imgData = canvas.toDataURL('image/jpeg', 1.0);
            const link = document.createElement('a');
            link.href = imgData;
            link.download = `baolin-vegefest-id-${guestId}.jpg` // File name for the downloaded file
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }).catch(error => {
            console.error("Error generating JPEG", error);
        });
    };

    const cardBackgroundStyle = {
        // Default background that will be applied on larger screens
        backgroundImage: `linear-gradient(to left, rgba(255, 255, 255, 0.72), rgba(255, 255, 255, 0.96)), url(${require("../../../assets/img/baolinPrivate/vegefest2026_ticket_bg.jpg")})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat"
    };

    // Style for the lotus divider image
    const dividerStyle = {
        width: '50%', // Sets the width to match the parent container
        height: '100%', // Keeps the aspect ratio of the image
        maxWidth: '100%', // Ensures that the image doesn't exceed its original size
        // maxWidth: '100%', // Ensures that the image doesn't exceed its original size
        // display: 'block', // To prevent default inline behavior that includes white space
        // margin: 'auto' // To center the image in the available column space
    };

    const ticketContent = (
        <>
            <div id="ticket-content">

                <div className="d-flex justify-content-center mb-3">
                    {/* <img src={cuteVege1} alt="Company Logo" width="20" className="mr-3" /> */}
                    <div className="text-center">
                        <h3 className="font-weight-bold font-size-lg text-info mb-3">
                            <img src={cuteVege1} alt="Company Logo" width="40" className="ml-3" />
                            <span className="m-4">寶林素食展</span>
                            <img src={cuteVege2} alt="Company Logo" width="40" className="mr-3" />
                        </h3>
                        <span className="font-weight-bold font-size-lg d-block">
                            {eventName}
                        </span>

                    </div>
                    
                </div>


                {/* {Announcement} */}
                <hr style={{ borderColor: '#ddd', marginTop: 0, marginBottom: '1rem' }} />
                <Row>
                    <Col md={{ span: 4, offset: 1 }} className="d-flex flex-column justify-content-center align-items-center">

                        <Card className="bg-light text-center">
                            <CardBody>
                                <CardSubtitle className="mb-2 .text-black-50 font-weight-bold">Guest ID</CardSubtitle>
                                <span className="font-size-lg mb-0 text-center text-guest-id">
                                    {formattedGuestId}
                                </span>
                            </CardBody>
                        </Card>


                        <QRCodeCanvas value={qrValue} size={170} level={"H"} className="mt-3" />
                        <span className="font-size-md mb-0 text-center">
                            請掃碼報到
                        </span>
                        <span className="font-size-md mb-0">
                            Scan QR code to check in 
                        </span>
                    </Col>

                    <Col md={{ span: 2 }} className=" d-none d-md-block">
                        <img
                            src={require("../../../assets/img/baolinPrivate/lotus_divider.png")}
                            alt="divider"
                            style={dividerStyle}
                        />
                    </Col>
                    <Col md={{ span: 4 }} className="d-flex justify-content-center">
                        <Container className="mt-5">
                            <Row>
                                <Col> {/* This will take the full width of the row by default */}
                                    <Card className="bg-light text-center">
                                        <CardBody>
                                            <span className="custom-text-lg d-block">Dec 19<sup>th</sup>, 2026</span>
                                            <span className="custom-text-lg d-block">12月19日</span>
                                            <CardSubtitle className="mb-2 .text-black-50">Saturday</CardSubtitle>
                                            <CardSubtitle className="mb-2 .text-black-50">星期六</CardSubtitle>
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>

                            <Row className="justify-content-left">
                                <div className="table-responsive">
                                    <Table>
                                        <thead>
                                            <tr>
                                                <th className="text-center font-weight-bold">Event</th>
                                                <th className="text-center font-weight-bold">
                                                    Time
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td className="text-center font-weight-bold" >
                                                    <span className="d-block">素食展</span>
                                                    <span className="d-block">BAO LIN VEGE FEST</span>
                                                </td>
                                                <td className="text-center">
                                                    <span className="font-weight-bold d-block">
                                                        {timeslot || "11:30AM~02:30PM"}
                                                    </span>
                                                </td>
                                            </tr>
                                        
                                        </tbody>
                                    </Table>
                                </div>
                            </Row>

                            {timeslot && (
                                <Row>
                                    <Col>
                                        <Alert
                                            variant="warning"
                                            className="text-center mt-2 mb-0"
                                            style={{
                                                fontSize: '1rem',
                                                // The theme's warning alert is white on orange (~2.3:1);
                                                // this is the one line a guest must be able to read.
                                                backgroundColor: '#fff4db',
                                                borderColor: '#f0a43b',
                                                color: '#7a4c00'
                                            }}
                                        >
                                            <span className="d-block font-weight-bold">
                                                Your entry time: {timeslot}
                                            </span>
                                            <span className="d-block">Please arrive on time.</span>
                                            <span className="d-block font-weight-bold mt-2">
                                                您的入場時段 {timeslot}
                                            </span>
                                            <span className="d-block">請準時入場</span>
                                        </Alert>
                                    </Col>
                                </Row>
                            )}

                        </Container>
                    </Col>

                </Row>


            </div>
        </>)

    const ticket = (
        <>
            <Card className="card-box mb-5 p-4" id="ticket-for-download" style={{ ...cardBackgroundStyle }}>
                {ticketContent} {/* Render the ticket content */}
            </Card>
            <Row className="mt-1">
                {/* <Col>
                    <Button
                        className="btn-round btn-wd mr-1 "
                        style={{ fontWeight: 'bold' }}
                        href="#/"
                        type="button"
                        onClick={(e) => {
                            e.preventDefault(); // Prevent the default anchor action
                            addToCalendar();
                        }}
                        variant="success"
                        size="md"
                        outline
                        block
                    >
                        <FontAwesomeIcon icon={faCalendar} />  {language === "English" ? "Download Calendar Event" : "下載日曆活動"}
                    </Button>
                </Col> */}
                <Col>
                    <Button
                        tag="a"
                        href="#/"
                        onClick={(e) => {
                            e.preventDefault(); // Prevent the default anchor action
                            downloadImage();
                        }}
                        style={{ fontWeight: 'bold' }}
                        size="md"
                        className="btn-round btn-wd mr-1"
                        outline
                        variant="primary"
                        block
                    >
                        <FontAwesomeIcon icon={faTicket} />  {language === "English" ? "Download Ticket as JPEG" : "下載入場券"}
                    </Button>
                </Col>
                <Col>
                    <Button
                        tag="a"
                        href="#/"
                        onClick={redirectToRegister}
                        style={{ fontWeight: 'bold' }}
                        size="md"
                        className="btn-round btn-wd mr-1"
                        outline
                        variant="success"
                        block
                    >
                        {language === "English" ? "Register more" : "繼續報名"} <FontAwesomeIcon icon={faArrowRight} />
                    </Button>
                </Col>
            </Row>
        </>
    );
    return (
        <>
            <Guest>
                <div className="content d-flex align-items-center p-0">
                    <Container>
                        {ticket}

                    </Container>
                </div>

            </Guest >
        </>
    );
}

export default EventTicket;
